import { endDateTime, startDateTime } from '~/common/utils/date-time.utils';

import type { AssetsState } from '../assetsSlice';
import {
  advisorVehicleListAdapter,
  assetComplianceAdapter,
  assetEventsAdapter,
  assetLocationsAdapter,
  assetPeripheralVehicleAdapter,
  assetReportItemsAdapter,
  assetSearchAdapter,
  assetsAdapter,
  assetVehicleNotificationAdapter,
  pendingVehicleAdapter,
} from './assetsSlice.adapters';

export const INITIAL_ASSETS_STATE = assetsAdapter.getInitialState<AssetsState>({
  assetVehicleNotificationList:
    assetVehicleNotificationAdapter.getInitialState(),
  assetPeripheralVehicleList: assetPeripheralVehicleAdapter.getInitialState(),
  nextEPalletSerial: '',
  trackerSerials: [],
  ePalletVersions: [],
  assetEvents: assetEventsAdapter.getInitialState(),
  assetLocations: assetLocationsAdapter.getInitialState(),
  operations: {},
  pendingVehiclesList: pendingVehicleAdapter.getInitialState(),
  sessionConfigs: {},
  startDate: startDateTime().toString(),
  endDate: endDateTime().toString(),
  pendingAssetOperation: undefined,
  selectedMarkerId: '',
  assetList: assetSearchAdapter.getInitialState(),
  assetReportItems: assetReportItemsAdapter.getInitialState(),
  assetComplianceList: assetComplianceAdapter.getInitialState(),
  advisorVehiclesList: advisorVehicleListAdapter.getInitialState(),
  activeBatches: {},
});
